/* eslint-disable vue/no-reserved-component-names */
/* eslint-disable vue/multi-word-component-names */
import PrimeVue from 'primevue/config';

import { transicaoOverlay } from '@/plugins/animacoes/transicaoOverlay';

import TieredMenu from 'primevue/tieredmenu';
import IconField from 'primevue/iconfield';
import InputIcon from 'primevue/inputicon';
import Skeleton from 'primevue/skeleton';
import PanelMenu from 'primevue/panelmenu';
import ConfirmPopup from 'primevue/confirmpopup';
import Fieldset from 'primevue/fieldset';
import InputText from 'primevue/inputtext';
import InputMask from 'primevue/inputmask';
import Checkbox from 'primevue/checkbox';
import Button from 'primevue/button';
import Avatar from 'primevue/avatar';
import ripple from 'primevue/ripple';
import styleclass from 'primevue/styleclass';
import Badge from 'primevue/badge';
import DataTable from 'primevue/datatable';
import DataView from 'primevue/dataview';
import Column from 'primevue/column';
import Dialog from 'primevue/dialog';
import Textarea from 'primevue/textarea';
import InputSwitch from 'primevue/inputswitch';
import FileUpload from 'primevue/fileupload';
import Toast from 'primevue/toast';
import ToastService from 'primevue/toastservice';
import Toolbar from 'primevue/toolbar';
import Dropdown from 'primevue/dropdown';
import Tag from 'primevue/tag';
import TabView from 'primevue/tabview';
import TabPanel from 'primevue/tabpanel';
import Calendar from 'primevue/calendar';
import Chip from 'primevue/chip';
import InputNumber from 'primevue/inputnumber';
import OverlayPanel from 'primevue/overlaypanel';
import Message from 'primevue/message';
import ConfirmDialog from 'primevue/confirmdialog';
import Tooltip from 'primevue/tooltip';
import Timeline from 'primevue/timeline';
import Card from 'primevue/card';
import MultiSelect from 'primevue/multiselect';
import Menu from 'primevue/menu';
import Editor from 'primevue/editor';
import AutoComplete from 'primevue/autocomplete';
import Image from 'primevue/image';
import Divider from 'primevue/divider';
import Password from 'primevue/password';
import BadgeDirective from 'primevue/badgedirective';
import SelectButton from 'primevue/selectbutton';
import RadioButton from 'primevue/radiobutton';
import Slider from 'primevue/slider';
import Panel from 'primevue/panel';
import InlineMessage from 'primevue/inlinemessage';
import ProgressSpinner from 'primevue/progressspinner';
import ProgressBar from 'primevue/progressbar';
import ConfirmationService from 'primevue/confirmationservice';
import Paginator from 'primevue/paginator';
import ContextMenu from 'primevue/contextmenu';
import Accordion from 'primevue/accordion';
import AccordionTab from 'primevue/accordiontab';
import TreeSelect from 'primevue/treeselect';

import 'primevue/resources/themes/lara-light-indigo/theme.css';
import 'primevue/resources/primevue.min.css';
import 'primeicons/primeicons.css';
import 'primeflex/primeflex.css';

export function setupPrimeVue(app, locale_pt_br) {
  app.use(PrimeVue, {
    ripple: true,
    locale: locale_pt_br(),
    pt: {
      Calendar: {
        root: { class: 'text-xs' },
        input: { class: 'text-xs' },
        panel: { class: 'text-xs' },
        header: { class: 'text-xs p-1' },
        title: { class: 'text-xs' },
        monthTitle: { class: 'text-xs' },
        yearTitle: { class: 'text-xs' },
        decadeTitle: { class: 'text-xs' },
        previousButton: { class: 'text-xs' },
        nextButton: { class: 'text-xs' },
        table: { class: 'text-xs' },
        tableHeaderCell: { class: 'text-xs p-1' },
        weekHeaderLabel: { class: 'text-xs' },
        weekDay: { class: 'text-xs' },
        weekNumber: { class: 'text-xs' },
        day: { class: 'text-xs p-1' },
        dayLabel: { class: 'text-xs' },
        month: { class: 'text-xs' },
        year: { class: 'text-xs' },
        hour: { class: 'text-xs' },
        minute: { class: 'text-xs' },
        second: { class: 'text-xs' },
        ampm: { class: 'text-xs' },
        buttonbar: { class: 'text-xs p-1' },
        todayButton: { class: 'text-xs' },
        clearButton: { class: 'text-xs' },
      },
      Button: {
        icon: 'text-xs',
        label: 'text-xs font-medium',
      },
      progressspinner: {
        root: {
          style: 'width: 50px; height: 50px',
        },
        spinner: {
          strokeWidth: '7',
          class: 'text-primary',
        },
        circle: {
          style: 'stroke: #06090e !important',
        },
      },
      MultiSelect: {
        input: { class: 'text-sm' },
        root: { class: 'text-sm' },
        item: { class: 'text-sm' },
        emptyMessage: { class: 'text-sm' },
        trigger: {
          style: 'width: 12px;margin-left: 10px;margin-right: 10px;',
        },
      },
      dropdown: {
        transition: transicaoOverlay,
        header: { style: 'padding: 0; border-radius: 0 !important; background: none !important;' },
        filterInput: ({ props }) => ({
          class: 'text-sm',
          style: 'padding-left: 20px; border-bottom-right-radius: 0 !important; border-bottom-left-radius: 0 !important; box-shadow: none; border: none;',
          placeholder: props.filterPlaceholder || 'Buscar',
        }),
        input: { class: 'text-sm w-full' },
        filterIcon: { class: 'text-xs', style: 'width: 13px' },
        clearIcon: { style: 'right: 30px; width: 13px;' },
        emptyMessage: { class: 'text-sm' },
        panel: { class: 'w-4rem mt-2' },
        item: { class: 'text-sm flex align-items-center w-full', style: 'white-space: break-spaces;' },
        itemLabel: { class: 'text-sm m-0 white-space-normal max-w-30rem ' },
        itemGroup: { class: 'text-sm' },
        itemGroupLabel: { class: 'text-sm' },
        trigger: {
          style: 'width: 12px;margin-left: 10px;margin-right: 10px;',
        },
        list: { class: 'p-0' },
      },
      InputMask: {
        input: { class: 'text-sm' },
        root: { class: 'text-sm' },
      },
      InputNumber: {
        input: { class: 'text-sm' },
        root: { class: 'text-sm' },
      },
      InputText: {
        input: { class: 'text-sm' },
        root: { class: 'text-sm' },
      },
      Menu: {
        content: { class: 'text-sm' },
        submenuheader: { class: 'text-xs font-semibold text-800' },
        label: { class: 'text-xs font-medium text-600' },
        action: { class: 'text-sm', tabindex: null },
        icon: { style: 'font-size: 10px;' },
      },
      SelectButton: {
        label: { class: 'text-xs' },
      },
      Checkbox: {
        root: { style: 'width: 18px; height: 18px;' },
        box: { style: 'width: 18px; height: 18px;' },
      },
      DataTable: {
        table: { style: 'min-width: 15rem;' },
        header: { class: 'border-none px-0' },
        wrapper: {
          class: 'border-round-2xl border-1 border-200',
          style: 'background:none !important;',
        },
        bodyrow: { style: 'background:none !important;' },
        emptyMessageCell: {
          class: 'border-none surface-ground text-900 text-sm',
        },
        paginator: {
          root: {
            class: 'text-sm',
            style: 'background: none !important;',
          },
          firstPageIcon: {
            style: 'width: 0.8rem;',
          },
          previousPageIcon: {
            style: 'width: 0.8rem;',
          },
          nextPageIcon: {
            style: 'width: 0.8rem;',
          },
          lastPageIcon: {
            style: 'width: 0.8rem;',
          },
          pageButton: {
            style: 'font-size: 0.8rem',
          },
          rowPerPageDropdown: {
            root: { style: 'height: 42px;' },
            input: { class: 'text-sm' },
            item: { class: 'text-sm' },
            trigger: {
              style: 'width: 12px;margin-left: 10px;margin-right: 10px;',
            },
          },
        },
      },
      Column: {
        headercell: {
          class:
            'text-500 bg-transparent rounder font-medium justify-content-center text-xs py-3 border-none',
        },
        bodycell: {
          class: 'border-none border-top-1 surface-ground text-900 font-semibold text-sm',
        },
        filterconstraint: { class: 'pb-0 ' },
        sort: { class: 'text-500 text-xs' },
        sorticon: { style: 'width: 0.8rem;', class: 'text-xs' },
        filtermenuicon: { style: 'width: 0.8rem;', class: 'text-500' },
      },
      Tooltip: {
        arrow: { class: 'hidden' },
      },
      Toolbar: {
        root: { class: 'p-0 border-none gap-3' },
        start: { class: 'flex align-items-center gap-2 md:gap-3 w-full md:w-max' },
        end: { class: 'w-full md:w-max' },
      },
      AutoComplete: {
        input: { class: 'text-sm' },
        item: { class: 'text-sm flex align-items-center w-full' },
        itemLabel: { class: 'text-sm m-0 white-space-normal' },
        emptymessage: { class: 'text-sm pl-4' },
        panel: { class: 'w-4rem' },
      },
      Panel: {
        header: { class: 'text-sm font-regular text-900' },
        title: { style: 'font-weight: 500;' },
      },
      Textarea: {
        input: { class: 'text-sm' },
        root: { class: 'text-sm' },
      },
      Tag: {
        root: {
          class: 'text-xs font-medium',
          style: 'padding: 0.2rem 0.55rem !important; font-size: 11px !important',
        },
      },
    },
  });

  app.use(ToastService);
  app.use(ConfirmationService);

  // Ao fechar o diálogo de confirmação pelo ESC (ou clique fora), o PrimeVue chama
  // apenas `onHide`, sem disparar o `reject`. Isso deixava estados de carregamento
  // presos nas telas que abrem o confirm antes de submeter. Aqui o `reject` passa a
  // ser executado também nesses casos, para todos os confirms da aplicação.
  const confirmacao = app.config.globalProperties.$confirm;
  const requireOriginal = confirmacao.require;

  confirmacao.require = (opcoes = {}) => {
    requireOriginal({
      ...opcoes,
      onHide: () => {
        opcoes.onHide?.();
        opcoes.reject?.();
      },
    });
  };

  app.component('Accordion', Accordion);
  app.component('AccordionTab', AccordionTab);
  app.component('TreeSelect', TreeSelect);
  app.component('ContextMenu', ContextMenu);
  app.component('TieredMenu', TieredMenu);
  app.component('IconField', IconField);
  app.component('InputIcon', InputIcon);
  app.component('Paginator', Paginator);
  app.component('ProgressSpinner', ProgressSpinner);
  app.component('Skeleton', Skeleton);
  app.component('PanelMenu', PanelMenu);
  app.component('ConfirmPopup', ConfirmPopup);
  app.component('InlineMessage', InlineMessage);
  app.component('Panel', Panel);
  app.component('Fieldset', Fieldset);
  app.component('InputText', InputText);
  app.component('InputMask', InputMask);
  app.component('Checkbox', Checkbox);
  app.component('Badge', Badge);
  app.component('Button', Button);
  app.component('Avatar', Avatar);
  app.component('DataTable', DataTable);
  app.component('DataView', DataView);
  app.component('Column', Column);
  app.component('Dialog', Dialog);
  app.component('Textarea', Textarea);
  app.component('InputSwitch', InputSwitch);
  app.component('FileUpload', FileUpload);
  app.component('Toast', Toast);
  app.component('Toolbar', Toolbar);
  app.component('Dropdown', Dropdown);
  app.component('Tag', Tag);
  app.component('TabView', TabView);
  app.component('TabPanel', TabPanel);
  app.component('Calendar', Calendar);
  app.component('Chip', Chip);
  app.component('InputNumber', InputNumber);
  app.component('OverlayPanel', OverlayPanel);
  app.component('Message', Message);
  app.component('ConfirmDialog', ConfirmDialog);
  app.component('Timeline', Timeline);
  app.component('Card', Card);
  app.component('MultiSelect', MultiSelect);
  app.component('Menu', Menu);
  app.component('Editor', Editor);
  app.component('AutoComplete', AutoComplete);
  app.component('Image', Image);
  app.component('Divider', Divider);
  app.component('Password', Password);
  app.component('SelectButton', SelectButton);
  app.component('RadioButton', RadioButton);
  app.component('ProgressBar', ProgressBar);
  app.component('Slider', Slider);

  app.directive('ripple', ripple);
  app.directive('styleclass', styleclass);
  app.directive('badge', BadgeDirective);
  app.directive('tooltip', Tooltip);
}
